import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { IRegistrationSelectedSectionsModel } from '../models/registration_selected_sections_model';
import { ISection } from '../../../interfaces/scheduler_interfaces';

interface IRegistrationSelectedSectionsQueryResult {
  isRegistrationPending: boolean;
  disableRegistration: boolean;
  showRegistrationPrompt: boolean;
  isAnyScheduledSectionUnselected: boolean;
  hasAnyScheduledSectionMissingRequirements: boolean;
  hasAnyOptionalSectionNotScheduled: boolean;
  unscheduledOptionalSectionTypes: string[];
  unselectedSections: ISection[];
  coReqMissingSections: ISection[];
  preReqMissingSections: ISection[];
  isRequestPending: boolean;
}

export class RegistrationSelectedSectionsQuery implements IQuery {
  private _result: IRegistrationSelectedSectionsQueryResult;

  constructor(private ngRegistrationSelectedSectionsModel: IRegistrationSelectedSectionsModel) {
    Query.registerQuery(this, ngRegistrationSelectedSectionsModel);
  }

  run() {
    this._result = {
      isRegistrationPending: this.ngRegistrationSelectedSectionsModel.read().isRegistrationPending,
      disableRegistration: this.ngRegistrationSelectedSectionsModel.read().disableRegistration,
      showRegistrationPrompt: this.ngRegistrationSelectedSectionsModel.read().showRegistrationPrompt,
      isAnyScheduledSectionUnselected: this.ngRegistrationSelectedSectionsModel.read().isAnyScheduledSectionUnselected,
      hasAnyScheduledSectionMissingRequirements:
        this.ngRegistrationSelectedSectionsModel.read().hasAnyScheduledSectionMissingRequirements,
      hasAnyOptionalSectionNotScheduled:
        this.ngRegistrationSelectedSectionsModel.read().hasAnyOptionalSectionNotScheduled,
      unscheduledOptionalSectionTypes: this.ngRegistrationSelectedSectionsModel.read().unscheduledOptionalSectionTypes,
      unselectedSections: this.ngRegistrationSelectedSectionsModel.read().unselectedSections,
      coReqMissingSections: this.ngRegistrationSelectedSectionsModel.read().coReqMissingSections,
      preReqMissingSections: this.ngRegistrationSelectedSectionsModel.read().preReqMissingSections,
      isRequestPending: this.ngRegistrationSelectedSectionsModel.read().isRequestPending
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular
  .module('capability-ng-scheduler')
  .service('ngRegistrationSelectedSectionsQuery', RegistrationSelectedSectionsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/queries/registration_selected_sections_query.ts